// removed by extract-text-webpack-plugin
module.exports = {"submitBtn":"_3c7nnZMeqAfq2pCjodwSWh_0","wrapper":"C2jm29rH3wrw6I3-ySChv_0","form":"_3Xmlz1Waf8ITcZY-CPyIcN_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16a6969e","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserInfo/User.vue
// module id = uiFV
// module chunks = 0